import { Component, Vue } from 'vue-property-decorator';
import { TypeField, RegistrationField } from '@/types/Login';
import { AppModule } from '@/store/modules/app';
import { getCaptchaVerify } from '@/api/Auth';

@Component
export default class extends Vue {
  typeField = TypeField;

  regField = RegistrationField;

  isRecaptchaError = false;

  get applicantRegistrationFields() {
    return AppModule.setting?.login_tabs?.applicant_registration_fields || [];
  }

  get companyRegistrationFields() {
    return AppModule.setting?.login_tabs?.company_registration_fields || [];
  }

  public get isOnlyAbaSids() {
    return AppModule.sid.startsWith('abatest') || AppModule.sid.startsWith('abaooe') || AppModule.sid.startsWith('aba'); // for now only for abatest and abaooe
  }

  public get isAmseuSid() {
    return AppModule.sid === 'amseu';
  }

  // amseu shows 15008 — it embeds a `.terms-link` anchor that opens the terms/privacy modal;
  // every other sid keeps the plain consent text 14016
  public get privacyConsentTextId() {
    return this.isAmseuSid ? 15008 : 14016;
  }

  // wires the `.terms-link` inside the consent text (ref="content") to the shared `terms-modal`.
  // Re-runs whenever the translations arrive, so the dataset flag keeps the listener single.
  public initializeTermsModalLink() {
    const content = (this.$refs as any).content as HTMLElement | undefined;
    const termsLink = content?.querySelector('.terms-link') as HTMLElement | null;
    if (!termsLink || termsLink.dataset.termsModalBound) return;
    termsLink.dataset.termsModalBound = 'true';
    termsLink.addEventListener('click', (event: Event) => {
      event.preventDefault();
      this.$bvModal.show('terms-modal');
    });
  }

  isField(type: TypeField, name: string, fields: any[]) {
    if (fields?.length) {
      const field = fields.find((x: any) => x.name === name);
      return field ? field[type] : false;
    }
    return false;
  }

  isApplicantField(type: TypeField, name: RegistrationField | string) {
    return this.isField(type, name, this.applicantRegistrationFields);
  }

  isCompanyField(type: TypeField, name: RegistrationField | string) {
    return this.isField(type, name, this.companyRegistrationFields);
  }
}
